import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AgentApprovals } from "@/components/AgentApprovals";

export default function Agents() {
  const [agents, setAgents] = useState([]);
  const { user: me } = useAuth();
  const load = () => api.get("/users").then((r) => setAgents(r.data.filter((u) => u.role === "agent")));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="agents-page">
      <AgentApprovals agents={agents} isAdmin={me?.role === "admin"} reload={load} />
    </div>
  );
}
